import type { Filter } from '../../types/Filter';
import type ApiFeaturesValues from '../features/types/ApiFeaturesValues';

export default (
  filter: Filter,
  params: Partial<ApiFeaturesValues> | Record<string, never>,
): string[] => {
  return params[filter.filter_key] ? params[filter.filter_key].split(',') : [];
};
